import {
    PatientPreconfigDetail,
    PreconfigInquiry,
    PreconfigSheetParameter,
    Preconfiguration
} from '../interfaces/Preconfigurations';
import { PatientInquiry } from '../interfaces/Poll';

export interface PreconfigFormData {
    name: string
    profileIds: number[]
    pathologyIds: number[]
    inquiries: PreconfigInquiry[]
    sheetParameters: PreconfigSheetParameter[]
}

type PatientPreconfigOverrideInquiryInput = Pick<
    PatientInquiry,
    | 'id'
    | 'inquiry_id'
    | 'frecuency'
    | 'monthly_frequency_day'
    | 'semanal_frequency'
    | 'frequency_duration'
    | 'reminder_time'
>;

export interface PatientPreconfigOverridePayload {
    preconfig_sheet_parameters: Array<{
        id?: number
        preconfig_id: number | null
        sheet_parameter_id?: string
        max_limit?: number | null
        min_limit?: number | null
        frecuency?: number | null
        monthly_frequency_day?: number | null
        semanal_frequency?: number[] | null
        frequency_duration?: number | null
        reminder_time?: string | null
        override_delete?: boolean
    }>
    preconfig_inquiries: Partial<PreconfigInquiry>[]
}

export const toPreconfigFormData = (
    preconfig?: Preconfiguration
): PreconfigFormData => ({
    name: preconfig?.name ?? '',
    profileIds: preconfig?.profiles?.map(p => p.id) ?? [],
    pathologyIds: preconfig?.pathologies?.map(p => p.id) ?? [],
    inquiries: preconfig?.preconfig_inquiries ?? [],
    sheetParameters: preconfig?.preconfig_sheet_parameters ?? [],
});

export const toPreconfigUpsertPayload = ({
    name,
    profileIds,
    pathologyIds,
    inquiries,
    sheetParameters,
}: PreconfigFormData) => ({
    name,
    profile_ids: profileIds,
    pathology_ids: pathologyIds,
    preconfig_inquiries: inquiries.map(i => {
        const newI = { ...i };
        delete newI.inquiry;
        return newI;
    }),
    preconfig_sheet_parameters: sheetParameters.map(param => ({
        id: param.id,
        preconfig_id: param.preconfig_id,
        sheet_parameter_id: param.sheet_parameter_id,
        max_limit: param.max_limit,
        min_limit: param.min_limit,
        frecuency: param.frecuency,
        monthly_frequency_day: param.monthly_frequency_day,
        semanal_frequency: param.semanal_frequency,
        frequency_duration: param.frequency_duration,
        reminder_time: param.reminder_time,
        override_delete: param.override_delete,
    })),
});

export const getEffectivePreconfig = (
    patientPreconfigDetail: PatientPreconfigDetail | null | undefined
): Preconfiguration | null => {
    if (!patientPreconfigDetail) return null;
    return patientPreconfigDetail.override_preconfig ?? patientPreconfigDetail.preconfig;
};

export const toPatientPreconfigOverridePayload = (
    preconfigSheetParameters: PreconfigSheetParameter[],
    preconfigInquiries: PatientPreconfigOverrideInquiryInput[]
): PatientPreconfigOverridePayload => ({
    preconfig_sheet_parameters: preconfigSheetParameters.map(param => ({
        id: param.id,
        preconfig_id: param.preconfig_id,
        sheet_parameter_id: param.sheet_parameter_id,
        max_limit: param.max_limit,
        min_limit: param.min_limit,
        frecuency: param.frecuency,
        monthly_frequency_day: param.monthly_frequency_day,
        semanal_frequency: param.semanal_frequency,
        frequency_duration: param.frequency_duration,
        reminder_time: param.reminder_time,
        override_delete: param.override_delete,
    })),
    preconfig_inquiries: preconfigInquiries.map(i => ({
        id: i.id,
        inquiry_id: i.inquiry_id,
        frecuency: i.frecuency,
        monthly_frequency_day: i.monthly_frequency_day,
        semanal_frequency: i.semanal_frequency,
        frequency_duration: i.frequency_duration,
        reminder_time: i.reminder_time,
    })),
});